module.exports = __webpack_public_path__ + "static/img/state-vs-privately-educated-grads.0262f4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/thumbs/state-vs-privately-educated-grads.png
// module id = e7pq
// module chunks = 0